import { render, staticRenderFns } from "./dropdownIcon.vue?vue&type=template&id=12bbb930&scoped=true"
import script from "./dropdownIcon.vue?vue&type=script&lang=js"
export * from "./dropdownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbb930",
  null
  
)

export default component.exports